export default __webpack_public_path__ + "static/media/DSC_0507.9fdf8b6d.jpg";